"use strict";
/**
 * 错误处理工具函数
 *
 * 提供统一的错误消息提取和类型守卫
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractErrorMessage = extractErrorMessage;
exports.isError = isError;
/**
 * 从错误对象中提取错误消息
 *
 * @param error 错误对象（可能是 Error、字符串或其他类型）
 * @returns 错误消息字符串
 */
function extractErrorMessage(error) {
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === 'string') {
        return error;
    }
    return String(error);
}
/**
 * 类型守卫：判断是否为 Error 实例
 *
 * @param error 待判断的值
 * @returns 是否为 Error 实例
 */
function isError(error) {
    return error instanceof Error;
}
